import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const TagWithStatus = ({ isEnabled }: { isEnabled: boolean }) => (
    <Tag variant={isEnabled ? 'success' : 'basicSubtle'}>
        <LocalizedText textKey={isEnabled ? TextKey.Active : TextKey.Deactivated} />
    </Tag>
);
